import type { Components, Theme } from '@mui/material/styles'

import { borderWidth, fontSize, spacing } from '@/themes/tokens'

export const MuiButtonOverride: Components<Theme>['MuiButton'] = {
  defaultProps: {
    variant: 'contained',
    size: 'medium'
  },
  styleOverrides: {
    root: {
      borderRadius: 8,
      textTransform: 'none',
      fontSize: fontSize.base
    },
    contained: {
      color: '#ffffff',
      boxShadow: 'none',
      minWidth: 'auto',
      '&:hover': {
        boxShadow: '0 0 16px 0 rgba(0, 113, 255, 0.24)'
      }
    },
    outlined: {
      borderWidth: borderWidth.thin
    },
    text: ({ theme }) => ({
      color: theme.palette.text.primary,
      minWidth: 'auto'
    })
  },
  variants: [
    {
      props: { size: 'large' },
      style: ({ theme }) => ({
        paddingLeft: theme.spacing(spacing.lg),
        paddingRight: theme.spacing(spacing.lg),
        paddingTop: theme.spacing(spacing.sm),
        paddingBottom: theme.spacing(spacing.sm)
      })
    }
  ]
}
